import React, { useEffect, useState } from "react"
import { Row, Col } from "antd"
import { fetchAuditLog, selectFilter, selectPagination, reset } from "./auditLogSlice"
import AuditLogFilter from "./components/AuditLogFilter"
import AuditLogTimeline from "./components/AuditLogTimeline"
import { useDispatch, useSelector } from "react-redux"

export default function AuditLogPage() {
    const dispatch = useDispatch()

    const pagination = useSelector(selectPagination)
    const filter = useSelector(selectFilter)

    const [loaded, setLoaded] = useState(false)
    const [fetchRecords, setFetchRecords] = useState(false)

    /**
     * The initial useEffect that runs based on the `loaded` state variable. This will
     * reset the auditLogSlice attributes, and then fetch the records with the initialState attrs
     */
    useEffect(() => {
        if (!loaded) {
            setLoaded(true)
            dispatch(reset())
            setFetchRecords(true)
        }
    }, [loaded, dispatch])

    /**
     * The useEffect that runs when fetchRecords is true... when the initial state
     * has been set and the auditLogSlice has been reset.
     */
    useEffect(() => {
        if (fetchRecords) {
            setFetchRecords(false)
            dispatch(fetchAuditLog(pagination, filter))
        }
    }, [fetchRecords, dispatch, pagination, filter])

    return (
        <>
            {/* Fixed-width filter column; the timeline takes the rest and wraps below the filters when there isn't room. */}
            <Row gutter={[24, 24]}>
                <Col flex="0 0 320px">
                    <div className="card audit-log-filter">
                        <div className="card-body" style={{ alignItems: "normal" }}>
                            <AuditLogFilter />
                        </div>
                    </div>
                </Col>

                <Col flex="1 1 480px" className="audit-log-timeline">
                    <AuditLogTimeline />
                </Col>
            </Row>
        </>
    )
}
